import { CopyToClipboard } from 'components/CopyToClipboard/CopyToClipboard';
import { TextInput } from 'components/TextInput/TextInput';
import { useRef } from 'react';
import type { FC, FocusEvent, FormEvent } from 'react';

interface Props {
  sharedViewId: string | null;
}

export const ShareViewDialogBody: FC<Props> = (props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleFocus = (e: FormEvent<HTMLInputElement>) => {
    const evt = e as FocusEvent<HTMLInputElement>;
    evt.target.select();
  };

  if (!props.sharedViewId) {
    return null;
  }

  const { origin } = window.location;
  const url = `${origin}/diagrams/share/${props.sharedViewId}`;

  return (
    <div className='relative'>
      <TextInput
        onFocus={handleFocus}
        readOnly
        inputRef={inputRef}
        suffixText={<CopyToClipboard text={url} />}
        type='text'
        value={url}
      />
    </div>
  );
};
